import { AccountType, IAccount } from "@wingspanhq/users/dist/lib/interfaces";

export const selectorPossiblePayoutAccounts = (accounts: IAccount[]) =>
  accounts.filter(
    account =>
      account.type === AccountType.Depository && account.canBeUsedFor?.payouts
  );
